import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { CmsService } from 'src/app/core/services/cms.service';
import { ProfileService } from 'src/app/core/services/profile.service';
import { TagManagerService } from 'src/app/core/services/tag-manager.service';
import { LogCategory, LoggerService, LogType, LogWidget } from '../../core/services/logger.service';
import { AnnouncementsService } from '../../services/announcements.service';
import { IWidgetComponent } from '../../shared/widget/i-widget-component';
import { Widget } from '../../shared/widget/widget';

// Announcements uses the following data in the Data property of its Widget.WidgetMeta
//   Data['Dismissed'] = string[] : An array of unique announcements IDs that have been "dismissed" (marked as read) 

@Component({
    selector: 'app-announcements',
    templateUrl: './announcements.component.html',
    styleUrls: ['./announcements.component.scss'],
    standalone: false
})
export class AnnouncementsComponent implements OnInit, OnDestroy, IWidgetComponent {
    public data: Widget;

    @HostBinding('class')
    get size(): string {

        var widgetSize = 'col-md-' + this.data.Size.toString();

        switch (this.data.Size) {
            case 4: {
                widgetSize += ' widget-small';
                break;
            }
            case 6: {
                widgetSize += ' widget-medium';
                break;
            }
            case 12: {
                widgetSize += ' widget-large';
                break;
            }
        }

        return widgetSize;
    }

    constructor(
        public annoucementService: AnnouncementsService,
        public cmsService: CmsService,
        private profile: ProfileService,    
        private logger: LoggerService,
        private tagmanager: TagManagerService,
    ) {
        this.log("constructor", null, LogCategory.Constructor);
    }
    private log(method: string = null, message = null, category: LogCategory = LogCategory.Default): void {
        method = (method) ? '.' + method + '()' : '';
        message = (message) ? message.toString() : '';
        this.logger.try(this.constructor.name + method + ': ' + message, LogType.Widget, LogWidget.Announcements, category);
    }

    ngOnInit() {
        this.log("ngOnInit", null, LogCategory.Init);
    }

    ngOnDestroy() {
        this.log("ngOnDestroy", null, LogCategory.Destroy);
    }

    // See if the given id has been previously dismissed by the user. 
    public toggleDismissed(announcement): void {

        // Toggle the announcement's dismissed setting 
        announcement.isDismissed = !announcement.isDismissed;

        // Tell the services that something has changed. This allows it to recalculate the dismissedIds that we need
        // to save back to the profile. We can't just update the profile in the service because it doesn't have access
        // to this.data.meta, which is what gets updated in the profile. 
        this.annoucementService.updateDismissals$.next(true);

        // This is part of widget metadata, which gets updated in the profile. dismissedIds was recalculated
        // syncronously above when we told the service that something changed. 
        this.data.meta.Data['Dismissed'] = this.annoucementService.dismissedIds.join(',');

        // Update the widget metadata
        this.profile.updateWidgetPreference(this.data.meta);

        // Send the analytics event, but only capture dismiss events 
        if (announcement.isDismissed)
            this.tagmanager.gaAnnouncementDismissed(this.data, announcement.Id)
    }

    public showDismissed : boolean = false; 
}
